import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { CustomersListPage } from "../../customers-list/customers-list";
import { CustomersServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { SearchServices } from '../../../services/searchs';
import { CustomersCreateInfoPage } from '../customers-create-info/customers-create-info';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationTicketsListPage } from '../../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';
import { InvoicesViewPage } from '../../../invoices/invoices-view/invoices-view';
import { CustomersTicketsInvoicesListPage } from '../../customers-tickets-invoices-list/customers-tickets-invoices-list';
import { CustomersElementsListPage } from '../../customers-elements-list/customers-elements-list';
import { ReservationCalendarPage } from '../../../reservation/reservation-calendar/reservation-calendar';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { AnalyticsPage } from '../../../analytics/analytics';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * 
 * 
 */

@Component({
  selector: 'page-customers-create-data.html',
  templateUrl: 'customers-create-data.html',
})
export class CustomersCreateDataPage {
  //basic vars
  public form: FormGroup;
  customer_uid: any;
  update_state: boolean = false;
  address: any;
  quick_create: boolean = false;
  alegra_contact_id: any;
  //getAllInfoFromNode vars
  last_5_tickets: any;
  last_5_invoices: any;
  list_tickets: any;
  list_invoices: any;
  total_spent: number = 0;
  total_tickets: number = 0;
  average_ticket: number = 0;
  total_tips: number = 0;
  total_reservations: number = 0;
  total_orders: number = 0;
  total_elements_eaten: number = 0;
  customer_orders_labels;
  customer_orders_data;
  customer_orders_chartType: any;
  customer_orders_chartOptions: any;
  customer_orders_chartColors: any;
  customer_elements_eaten_labels = [];
  customer_list_all_elements = [];
  customer_elements_eaten_data = [];
  customer_top_5_elements = [];
  customer_elements_eaten_chartType: any;
  customer_elements_eaten_chartOptions: any;
  customer_elements_eaten_chartColors: any;


  fake_customer_orders_labels = [this.translate.instant('general-mesa'), this.translate.instant('general-takeaway'), this.translate.instant('general-delivery')];
  fake_customer_elements_eaten_labels = [this.translate.instant('general-plato') + ": a", this.translate.instant('general-plato') + ": b", this.translate.instant('general-plato') + ": c"]
  fake_data_orders = [[3], [3], [3]];
  fake_data_eaten = [3, 3, 3];

  example_customer_top_5_elements = [
    {
      name: this.translate.instant('general-plato') + ": a",
      units: 14
    }, {
      name: this.translate.instant('general-plato') + ": b",
      units: 10
    }, {
      name: this.translate.instant('general-plato') + ": c",
      units: 8
    }, {
      name: this.translate.instant('general-plato') + ": d",
      units: 5
    }, {
      name: this.translate.instant('general-plato') + ": e",
      units: 3
    }];
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };
  activeTab: string = 'ticketsCliente';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public customersServices: CustomersServices,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public searchService: SearchServices,
    public http: HttpClient) {
    this.initGetFormAndData();
    //grafica tipos de pedidos realizados
    this.customer_orders_chartType = 'horizontalBar';
    this.customer_orders_chartOptions = {
      responsive: true,
      legend: {
        display: true,
        position: 'right',
        labels: {
          // This more specific font property overrides the global property
          fontColor: 'black',
          //fontStyle: 'bold'
          fontSize: 15
        }
      },
      scales: {
        xAxes: [{
          display: false,
          stacked: true
        }],
        yAxes: [{
          display: false,
          stacked: true
        }]
      }
    }

    this.customer_orders_chartColors = [

      {
        backgroundColor: '#f6a316',
      },
      {
        backgroundColor: '#fab651',
      },
      {
        backgroundColor: '#fcc981',
      },
      {
        backgroundColor: '#fedcad',
      },
      {
        backgroundColor: '#ffedd7',
      },
      {
        backgroundColor: '#f0f0f0',
      },
      {
        backgroundColor: '#ededed',
      },
      {
        backgroundColor: '#dadada',
      },
      {
        backgroundColor: '#f0f0f0',
      },
      {
        backgroundColor: '#b2b2b2',
      },
    ];

    //grafica elementos consumidos
    this.customer_elements_eaten_chartType = 'horizontalBar';
    this.customer_elements_eaten_chartOptions = {
      legend: {
        display: false,
        position: 'top',
      }
    }
    this.customer_elements_eaten_chartColors = [
      {
        // grey
        backgroundColor: [
          '#f6a316',
          '#fab651',
          '#fcc981',
          '#fedcad',
          '#ffedd7',
          '#f0f0f0',
          '#ededed',
          '#dadada',
          '#c6c6c6',
          '#b2b2b2'
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
  }

  ionViewWillEnter() {
    if (!this.globals.checkLimitsByLicense('sales', 'customers')) {
      this.navCtrl.pop();
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.initGetFormAndData();
      ////version pro abierto ir a buscar a node
      if (this.globals.checkLimitsByLicense('sales', 'customers_analytics')) {
        this.getAllInfoFromNode();
      }
    }

  }

  initGetFormAndData() {
    this.globals.GAtrackView('Customers', 'Customers - View ', this.globals.restaurant.email, 'View', 'View customer', 'Customers', '');
    //Params
    this.update_state = this.navParams.get('update_state');
    this.customer_uid = this.navParams.get('customer_uid');


    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.alegra_contact_id = this.navParams.get('alegra_contact_id');
    loadingPopup.dismiss();

    if (this.update_state) {
      this.form = this.fb.group({
        name: [this.navParams.get('name'), Validators.compose([Validators.required])],
        business_name: [this.navParams.get('business_name')],
        business_number: [this.navParams.get('business_number')],
        email: [this.navParams.get('email')],
        phone: [this.navParams.get('phone')],
        address: [this.navParams.get('address')],
        note: [this.navParams.get('note')],
      });


    } else {
      this.form = this.fb.group({
        name: ['', Validators.compose([Validators.required])],
        business_name: [''],
        business_number: [''],
        email: [''],
        phone: [''],
        address: [''],
        note: [''],
      });
    }
  }


  getAllInfoFromNode() {
    this.customer_list_tickets_in_restaurant();
    this.customer_list_invoices_in_restaurant();
    this.customer_total_spent_in_restaurant();
    this.customer_total_reservations_in_restaurant();
    this.customer_list_elements_eaten_in_restaurant();
  }

  //
  async customer_total_spent_in_restaurant() {
    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_total_spent_in_restaurant', body).subscribe(async data => {
      this.total_spent = data['total_spent'];
      this.total_tickets = data['total_tickets'];
      this.average_ticket = data['average_ticket'];
      this.total_tips = data['total_tips'];
      this.customer_orders_type_in_restaurant();
    },
      err => {
      });
  }
  //
  async customer_total_reservations_in_restaurant() {
    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_total_reservations_in_restaurant', body).subscribe(async data => {
      this.total_reservations = data['total_reservations'];
    },
      err => {
      });
  }
  //
  customer_orders_data_done = false;
  total_table;
  total_takeaway;
  total_delivery;

  async customer_orders_type_in_restaurant() {
    this.customer_orders_data_done = false;

    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_orders_type_in_restaurant', body).subscribe(async data => {
      this.total_orders = data['total_tickets'];
      //
      this.total_table = await this.passToPercentage(data['total_table']);
      this.total_takeaway = await this.passToPercentage(data['total_takeaway']);
      this.total_delivery = await this.passToPercentage(data['total_delivery']);
      this.customer_orders_data_done = true;
    },
      err => {
      });
  }
  //
  async customer_list_elements_eaten_in_restaurant() {
    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_list_elements_eaten_in_restaurant', body).subscribe(async data => {
      this.total_elements_eaten = data['total_elements_eaten'];
      this.customer_top_5_elements = data['list_top_5_elements'];
      this.customer_list_all_elements = data['list_all_elements'];
    },
      err => {
      });
  }
  //
  async customer_list_tickets_in_restaurant() {
    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_list_tickets_in_restaurant', body).subscribe(async data => {
      this.list_tickets = data['list_tickets'];
      this.last_5_tickets = data['last_5_tickets'];
    },
      err => {
      });
  }
  //
  async customer_list_invoices_in_restaurant() {
    const body = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', this.customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_list_invoices_in_restaurant', body).subscribe(async data => {
      this.list_invoices = data['list_invoices'];
      this.last_5_invoices = data['last_5_invoices'];
    },
      err => {
      });
  }


  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      }

    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-nombre-telefono-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {

    if (this.addres_format_google) {//Comprovamos si hay una adress formatada y le ponemos al form. Si no lo hacemos la primera vez no lo encuntra bien.
      this.form.value.address = this.addres_format_google;
    }

    this.providersServices.afs.collection('customers').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'business_name': this.form.value.business_name,
      'business_number': this.form.value.business_number,
      'email': this.form.value.email,
      'phone': this.form.value.phone,
      'address': this.form.value.address,
      'note': this.form.value.note,
      'created_at': new Date()
    }).then(async doc => {
      this.globals.GAtrackView('Customers', 'Customers - Create ', this.globals.restaurant.email, 'Create/Update', 'Create customer', 'Customers', this.form.value.name);
      //Recuperamos el cliente
      let customer = await this.customersServices.getCustomer(doc.id);
      //Seleccionamos el cliente en el buscador
      this.searchService.selectCustomer(customer);


      //Get the UID Document
      if (this.providersServices.quick_create) {
        this.providersServices.quick_create = false;
        this.navCtrl.pop();
      } else {
        this.navCtrl.push(CustomersListPage, {
          //update: false,
          //delibery_note_uid: doc.id,
        });
      }
    });
  }

  addres_format_google: any;
  public handleAddressChange(address) {
    this.addres_format_google = address.formatted_address;
    this.form.value.address = address.formatted_address;
  }

  edit() {
    this.navCtrl.push(CustomersCreateInfoPage, {
      update_state: true,
      customer_uid: this.customer_uid,
      name: this.form.value.name,
      business_name: this.form.value.business_name,
      business_number: this.form.value.business_number,
      email: this.form.value.email,
      phone: this.form.value.phone,
      address: this.form.value.address,
      note: this.form.value.note,

    });
  }

  openTicket(event) {
    if (event.type == 'click') {
      this.navCtrl.push(ConfigurationTicketsListPage, {
        state: 'closed',
        ticket: event.row,
      });
    }
  }

  openInvoices(event) {
    if (event.type == 'click') {
      this.navCtrl.push(InvoicesViewPage, {
        'type': 'pay',
        'invoice': event.row,
      });
    }
  }

  openTicketsInvoicesList(tab) {
    this.navCtrl.push(CustomersTicketsInvoicesListPage, {
      customer_uid: this.customer_uid,
      tab: tab,
      customer_name: this.form.value.name,
      customer_phone: this.form.value.phone
    });
  }

  openElementsList() {
    this.navCtrl.push(CustomersElementsListPage, {
      customer_uid: this.customer_uid,
      customer_list_all_elements: this.customer_list_all_elements,
      customer_name: this.form.value.name,
      customer_phone: this.form.value.phone
    });
  }

  openReservation() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationCalendarPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage);
  }

  styleIcon(total) {
    let styles = {
      'width': total + '%',
    };
    return styles;
  }

  passToPercentage(num) {
    var _return = ((num * 100) / this.total_tickets);
    return _return;
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/customers-create/customers-create-data/customers-create-data.ts